import { generateCatalogRoute } from '@/utils/create-router';
import { defineStore } from 'pinia'
import { RouteRecordRaw } from 'vue-router';
import router from '@/router';

export const permissionStore = defineStore('permission', {
  state: () => {
    return {
      routes: [] as RouteRecordRaw[],
      addRoutes: [] as RouteRecordRaw[]
    }
  },
  actions: {
    setRoutes(routes: RouteRecordRaw[]) {
      this.addRoutes = routes;
      this.routes = this.routes.concat(routes);
    },
    generateRoutes(menus: AppMenu[]): Promise<RouteRecordRaw[]> {
      return new Promise(resolve => {
        const routes = generateCatalogRoute(menus);
        routes.push({
          path: '/:pathMatch(.*)*',
          redirect: '/404',
        });

        this.setRoutes(routes);

        const route = router.getRoutes().find(route => route.name === 'Home')

        if(route) {
          this.routes.unshift(route)
        }
        resolve(routes);
      });
    }
  }
})